import { fetchCommonMarketCountCountriesRanks } from '@/pages/intelligence/services/storeRank';
// import { fetchMobileStoreRankDetailsCountriesRanks } from '@/pages/intelligence/services/storeRank';
import type { IRegionType } from '@/pages/intelligence/types/common';
import type { IStoreRankDetailsCountriesRanks } from '@/pages/intelligence/types/storeRank';

export async function fetchStoreRankDetailsCountriesRanksPlus(params: {
  entityType?: 'mobile' | (string & {});
  appIds: string[];
  source: string[];
  regionType?: IRegionType;
  regions: string[];
  endDate: string;
  unified_id?: string;
}): Promise<IStoreRankDetailsCountriesRanks[]> {
  let result: IStoreRankDetailsCountriesRanks[] = [];
  const {
    entityType = 'mobile',
    appIds = [],
    source = [],
    regions = [],
    endDate = '',
    unified_id: unifiedId = '',
  } = params;
  try {
    const paramsPlus = {
      entity_type: entityType,
      app_ids: appIds,
      source: Array.isArray(source) && source?.length > 0 ? source[0] : 'appstore top free',
      markets: regions,
      granularity: 'daily',
      date: endDate,
      id: unifiedId,
    };
    const res = await fetchCommonMarketCountCountriesRanks(paramsPlus);
    result = res?.data || [];
  } catch (exception) {}
  return result;
}
